import { render, staticRenderFns } from "./ProjectDetailInfo.vue?vue&type=template&id=18db9782"
import script from "./ProjectDetailInfo.vue?vue&type=script&lang=js"
export * from "./ProjectDetailInfo.vue?vue&type=script&lang=js"
import style0 from "./ProjectDetailInfo.vue?vue&type=style&index=0&id=18db9782&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports